import React from 'react';

import { isEventSupported, postMessageRN, runningInRNWebView, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';
import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';
import { TransactionList } from '@eika/transaction-list';
import { FormattedTransactions } from '@eika/transaction-list/src/TransactionList';

import { Content } from '../../components/shared/Content';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useInvoiceArchive from '../../fetchHooks/useInvoiceArchive';
import useTranslation from '../../hooks/useTranslation';
import { getInvoiceUrl } from '../../services/invoiceArchiveService';
import { FuturePaymentsEFaktura } from '../FuturePaymentsEFaktura';
import TransactionListSkeleton from '../TransactionList/TransactionListSkeleton';
import formatInvoices from './formatInvoices';

import './InvoiceArchive.scss';

const supportsPdfEvent = isEventSupported('openPdf');

const InvoiceArchive: React.FC = () => {
    const translated = useTranslation();
    const query = useInvoiceArchive();

    if (query.isError) {
        return (
            <Content>
                <ErrorCardWrapper exception={query.error} defaultError={translated.futurePaymentsErrorMessage}>
                    <Button onClick={() => query.refetch()}>{translated.tryAgain}</Button>
                </ErrorCardWrapper>
            </Content>
        );
    }

    if (query.data?.length === 0 && query.isSuccess) {
        return (
            <Content>
                <InfoCard skipBackground>
                    <RichIcon type={RichIconTypes.LANDSKAP} />
                    <InfoCard.TitleH2>{translated.invoiceArchive.noInvoices}</InfoCard.TitleH2>
                </InfoCard>
            </Content>
        );
    }

    const onClick = async (id: string) => {
        const url = await getInvoiceUrl({ value: id });
        if (runningInRNWebView && supportsPdfEvent) {
            postMessageRN({
                action: WebToRNAction.OPEN_EFAKTURA,
                payload: url,
            });
        } else {
            const windowOpen = window.open(
                url,
                'menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,noopener',
            );
            if (!windowOpen) {
                window.open(url, '_self');
            }
        }
    };

    const formattedDocuments: FormattedTransactions[] = formatInvoices(query.data ?? [], onClick, translated);

    return (
        <>
            <div className="invoice-archive__efaktura">
                <FuturePaymentsEFaktura />
            </div>
            {query.isLoading ? (
                <TransactionListSkeleton count={5} />
            ) : (
                <TransactionList transactions={formattedDocuments} reservedText="" />
            )}
        </>
    );
};

export default InvoiceArchive;
